
        <div class="modal__content">
            <div data-test-id="spinner" class="loader">Loading...</div>
        </div>
    